<template>
  <AuthLayout is-login>
    <Login />
  </AuthLayout>
</template>

<script>
  import Login from '../containers/auth/Login';
  import AuthLayout from '../layouts/Auth';

  export default {
    meta: {
      title: 'Login',
    },
    components: { AuthLayout, Login },
  };
</script>
